import Icon, { ThunderboltFilled, TruckFilled, CustomerServiceFilled, FireFilled } from "@ant-design/icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { CanisterSvg, OthersSvg, PropaneSvg, SewerSvg } from "../assets/svgs/svg"
import { faFaucet, faGasPump } from "@fortawesome/free-solid-svg-icons"
import { useSelector } from "react-redux"
import { selectRoles } from "../features/userRoles/userRolesSlice"

export const states = [
    "Alabama",
    "Alaska",
    "Arizona",
    "Arkansas",
    "California",
    "Colorado",
    "Connecticut",
    "Delaware",
    "District Of Columbia",
    "Florida",
    "Georgia",
    "Hawaii",
    "Idaho",
    "Illinois",
    "Indiana",
    "Iowa",
    "Kansas",
    "Kentucky",
    "Louisiana",
    "Maine",
    "Maryland",
    "Massachusetts",
    "Michigan",
    "Minnesota",
    "Mississippi",
    "Missouri",
    "Montana",
    "Nebraska",
    "Nevada",
    "New Hampshire",
    "New Jersey",
    "New Mexico",
    "New York",
    "North Carolina",
    "North Dakota",
    "Ohio",
    "Oklahoma",
    "Oregon",
    "Pennsylvania",
    "Rhode Island",
    "South Carolina",
    "South Dakota",
    "Tennessee",
    "Texas",
    "Utah",
    "Vermont",
    "Virginia",
    "Washington",
    "West Virginia",
    "Wisconsin",
    "Wyoming",
    "Alberta",
    "Ontario",
    "British Columbia",
    "District of Columbia",
    "Shropshire",
    "Northants",
    "Quebec",
    "Newfoundland and Labrador",
    "New Brunswick",
    "Manitoba",
    "Saskatchewan",
    "Nova Scotia",
    "Sonora",
]

export function formatCurrency(value, symbol = true) {
    if (!value) {
        value = "0.00"
    }

    var symbolConfig = symbol ? { style: "currency", currency: "USD" } : {}

    return new Intl.NumberFormat("en-US", symbolConfig).format(parseFloat(value))
}

export function roundHumanizedNumbers(value) {
    if (!value) {
        value = "0.00"
    }
    return new Intl.NumberFormat("en-US").format(Math.round(parseFloat(value)))
}

export function getIcon(name, hasCursor = true) {
    const defaultStyle = { cursor: hasCursor ? "pointer" : "default", paddingRight: "7px", fontSize: "15px" }
    if (name.includes("Electric")) return <ThunderboltFilled style={{ color: "yellow", ...defaultStyle }} />
    else if (name.includes("Waste")) return <TruckFilled style={{ color: "green", ...defaultStyle }} />
    else if (name.includes("Telecom")) return <CustomerServiceFilled style={{ color: "white", ...defaultStyle }} />
    else if (name.includes("Natural Gas")) return <FireFilled style={{ color: "orange", ...defaultStyle }} />
    else if (name.includes("Water")) return <FontAwesomeIcon icon={faFaucet} style={{ color: "skyblue", ...defaultStyle }} />
    else if (name.includes("Diesel")) return <FontAwesomeIcon icon={faGasPump} style={{ color: "gray", ...defaultStyle }} />
    else if (name.includes("Gasoline")) return <Icon component={CanisterSvg} style={{ color: "red", ...defaultStyle }} />
    else if (name.includes("Sewer")) return <Icon component={SewerSvg} style={{ color: "lightgreen", ...defaultStyle }} />
    else if (name.includes("Propane")) return <Icon component={PropaneSvg} style={{ color: "aliceblue", ...defaultStyle }} />
    else return <Icon component={OthersSvg} style={{ ...defaultStyle }} />
}

export function useCheckIfImportExportAllowed(){
    const roles = useSelector(selectRoles)
    if(roles.includes('super_admin') || roles.includes('muc_admin')) return true
    return false
}
